import {processApiRequest} from '../../Common/saga';
import * as ACTION from './constants';
import apiService from './apiService';
import {notification} from 'antd';
import {router} from '../../../system/routing';
import {t} from '../../../system/i18n';

export function* editShippingUser(action) {
    yield processApiRequest(ACTION.EDIT_SHIPPING_USER, () => apiService.editShippingUser(action.payload), action.payload);
}

export function* editShippingUserSuccess() {
    yield notification['success']({
        message: t('common:message.edit_shipping_user_success')
    });
    yield router.redirect('/config/shipping-users');
}
